import { isIBAN as assertIBAN } from 'validator';
export const restrictedIBANs = [
    'AT42 6000 0000 0108 0751',
    'AT68 1200 0104 1200 6400',
];
export function isIBAN(value) {
    const valueTrimmed = (value || '').replace(/ /g, '');
    return assertIBAN(valueTrimmed);
}
